import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { addToast } from 'containers/Toasts/actions'

import {
  getPushNotificationError,
  getPushNotificationSuccess,
  updatePushNotificationError,
  updatePushNotificationSuccess,
} from './actions'
import { PUSH_NOTIFICATION_REQUEST, UPDATE_PUSH_NOTIFICATION } from './constants'

const getPushNotificationEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(PUSH_NOTIFICATION_REQUEST.INITIATE).mergeMap(() =>
    api.settings
      .getPushNotificationSettings()
      .map((response) => getPushNotificationSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(getPushNotificationError, error)))
      .takeUntil(action$.ofType(PUSH_NOTIFICATION_REQUEST.CANCEL))
  )

const updatePushNotificationEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_PUSH_NOTIFICATION.INITIATE).mergeMap(() =>
    api.settings
      .updatePushNotificationSettings(
        store.getState().settings.profileSettings.pushNotifications.data
      )
      .mergeMap((response) =>
        Observable.of(
          addToast({ message: 'Successfully saved!' }),
          updatePushNotificationSuccess(response)
        )
      )
      .catch((error) => Observable.of(epicsErrorHandler(updatePushNotificationError, error)))
      .takeUntil(action$.ofType(UPDATE_PUSH_NOTIFICATION.CANCEL))
  )

export default combineEpics(getPushNotificationEpic, updatePushNotificationEpic)
